export const shouldNotifyIncomingMessage = ({
  data,
  user,
  showTicketWithoutQueue,
  showGroupNotification
}) => {
  const ticket = data?.ticket;
  const message = data?.message;
  if (data?.action !== "create" || !ticket || !message || message.fromMe) return false;

  const assignedToCurrentUser = Number(ticket.userId) === Number(user?.id);
  const isUnassigned = !ticket.userId;
  const belongsToUserQueue = user?.queues?.some(queue => Number(queue.id) === Number(ticket.queueId)) ||
    (!ticket.queueId && showTicketWithoutQueue === true);
  const canReceiveTicket = assignedToCurrentUser || (isUnassigned && belongsToUserQueue);
  const visibleStatus = ticket.status !== "lgpd" && ticket.status !== "nps" &&
    (ticket.status !== "group" ||
      (ticket.whatsapp?.groupAsTicket === "enabled" && showGroupNotification === true));

  return canReceiveTicket && visibleStatus;
};
